
import React from "react";
import { Button } from "react-bootstrap";

const NewsletterButton = ({ onOpen }) => {
  return (
    <Button className="btn-secondary newsletter-button" onClick={onOpen}>
      Newsletter
    </Button>
  );
};

export default NewsletterButton;
